import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../../features/auth/context/AuthContext';
import { useSocket } from '../../features/realtime/context/SocketContext';

const STATUS_LABELS = {
  at_warehouse: 'At Warehouse',
  in_transit: 'In Transit',
  arrived_ghana: 'Arrived in Ghana',
  ready_for_pickup: 'Ready for Pickup',
  out_for_delivery: 'Out for Delivery',
  delivered: 'Delivered',
};

export default function RealtimeAlerts() {
  const { user } = useAuth();
  const socket = useSocket();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (user?.role !== 'admin' || !socket) {
      return undefined;
    }

    const handleAdminChatUnread = (payload) => {
      if (location.pathname === '/admin/chats') {
        return;
      }

      toast(
        (toastInstance) => (
          <div style={{ display: 'grid', gap: 8 }}>
            <div style={{ fontWeight: 700 }}>New customer message</div>
            <div style={{ fontSize: 13, lineHeight: 1.5 }}>
              {payload.senderName}
              {payload.shippingMark ? ` (${payload.shippingMark})` : ''}: {payload.message}
            </div>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => {
                toast.dismiss(toastInstance.id);
                navigate('/admin/chats', {
                  state: {
                    startUser: {
                      id: payload.senderId,
                      full_name: payload.senderName,
                      shipping_mark: payload.shippingMark,
                    },
                  },
                });
              }}
            >
              Open chat
            </button>
          </div>
        ),
        {
          duration: 7000,
          id: `admin-chat-${payload.senderId}-${payload.message}`,
        }
      );
    };

    socket.on('admin:chat_unread', handleAdminChatUnread);
    return () => socket.off('admin:chat_unread', handleAdminChatUnread);
  }, [location.pathname, navigate, socket, user?.role]);

  useEffect(() => {
    if (user?.role !== 'customer' || !socket) {
      return undefined;
    }

    const handleStatusUpdated = (payload) => {
      const statusLabel = STATUS_LABELS[payload.status] || payload.status;
      const itemLabel = payload.goodsName || payload.trackingNumber || 'Your shipment';
      toast.success(`${itemLabel} is now ${statusLabel}.`, {
        id: `status-${payload.itemId}-${payload.status}`,
      });
    };

    socket.on('status:updated', handleStatusUpdated);
    return () => socket.off('status:updated', handleStatusUpdated);
  }, [socket, user?.role]);

  return null;
}
